"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Link
 */
var React = require("react");
var classNames = require("classnames");
var Aria_1 = require("../resources/Aria");
var util_1 = require("../utils/util");
var LinkType;
(function (LinkType) {
    /**
     * Navigation Link. Use to navigate to new screen.
     */
    LinkType["Navigation"] = "navigation";
    /**
     * Action Link. Use to perform light-weight actions, such as copying a string or revealing a set of fields.
     */
    LinkType["Action"] = "action";
})(LinkType = exports.LinkType || (exports.LinkType = {}));
var LinkTextStyle;
(function (LinkTextStyle) {
    /**
     * Default link text style.
     */
    LinkTextStyle["Default"] = "oui-link-text";
    /**
     * Link with success text style.
     */
    LinkTextStyle["Success"] = "oui-text-success";
    /**
     * Link with danger text style.
     */
    LinkTextStyle["Danger"] = "oui-text-danger";
    /**
     * Link text style for disabled action.
     */
    LinkTextStyle["Disabled"] = "oui-link-disabled oui-disabled";
    /*
     * Link contains an icon and no text.
     */
    LinkTextStyle["Icon"] = "oui-link-icon";
    /**
     * Assign no link text style.
     */
    LinkTextStyle["None"] = "";
})(LinkTextStyle = exports.LinkTextStyle || (exports.LinkTextStyle = {}));
/**
 * OUI link component.
 * Links are used for navigation (outside of the Primary Navigation Menu) and light-weight actions.
 *
 * @oui-component Link
 */
var Link = function (_a) {
    var linkType = _a.linkType, textStyle = _a.textStyle, icon = _a.icon, children = _a.children, openInNewWindow = _a.openInNewWindow, onClick = _a.onClick, _b = _a.href, href = _b === void 0 ? "#" : _b, title = _a.title, testId = _a.testId, rest = __rest(_a, ["linkType", "textStyle", "icon", "children", "openInNewWindow", "onClick", "href", "title", "testId"]);
    // href is a required attribute in <A> tag and `#` is a no-op link.
    // preventDefault to force the link to do nothing.
    var className = "";
    var onClickHandler = onClick;
    if (icon) {
        className = LinkTextStyle.Icon;
    }
    else {
        if (linkType === LinkType.Action) {
            className = classNames(textStyle, "oui-userselect-none");
            onClickHandler = function (event) {
                event && event.preventDefault();
                // If there's an onClick to call and the link isn't disabled
                if (onClick && textStyle !== LinkTextStyle.Disabled) {
                    onClick(event);
                }
            };
        }
        else if (linkType === LinkType.Navigation) {
            className = classNames(textStyle);
        }
    }
    var target = openInNewWindow ? "_blank" : undefined;
    var rel = openInNewWindow ? "noopener noreferrer" : undefined;
    var linkProps = __assign({}, rest, { target: target,
        title: title,
        rel: rel,
        className: className,
        href: href, onClick: onClickHandler }, util_1.ariaProps(rest), (linkType === LinkType.Action && { role: Aria_1.Roles.Button }), (textStyle === LinkTextStyle.Disabled && { tabIndex: -1 }));
    var iconSpan = icon ? React.createElement("span", { "data-oui-icon": "icon: " + icon }) : null;
    var linkContent = iconSpan || children;
    return (React.createElement("a", __assign({}, linkProps, { "data-test-id": testId }), linkContent));
};
Link.defaultProps = {
    linkType: LinkType.Navigation,
    openInNewWindow: false,
    textStyle: LinkTextStyle.None
};
exports.default = Link;
//# sourceMappingURL=Link.js.map